export const home = {
  pageHeader: {
    title: 'Home',
  },
  welcome: 'Welcome back, {{name}}!',
}
